import { Box } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";

function ProfileSettingSejamContainer() {
  const [isUpdated, setIsUpdated] = useState(false);
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      <Outlet context={{ isUpdated, setIsUpdated }} />
    </Box>
  );
}

export default ProfileSettingSejamContainer;
